import { Link, useHistory } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { columnsCsv, options, options1 } from "./user-contents";

import RakRechargePresentational from "./RakRechargePresentational";
import { ReachargetransactionData } from "../data.js";
import { getRechargeTransactionList } from "./utils";
import { getTabRechargeTransactionsDetails } from "../../../service/profile-ras-service";
import moment from "moment";

const RechargeTransaction = () => {
  const history = useHistory();
  const request = {
    page: 1,
    size: 10,
    name: "",
    applicationId: 1,
    beneficiaryName: "",
    receiver: "",
    sender: "",
    fromDate: "",
    toDate: "",
    status: "",
    c3REF: "",
  };
  const [filterForm, setFilterForm] = useState(request);
  const [modalShow, setModalShow] = useState(false);
  const [transactionDetailModel, setTransactionDetailModel] = useState(false);
  const [searchBy, setSearchBy] = useState("sender");
  const [searchByValue, setSearchByValue] = useState("");
  const [filterValues, setFilterValues] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState();
  const [blockStatus, setBlockStatus] = useState(false);
  const [verifiedStatus, setVerifiedStatus] = useState(false);
  const [activeStatus, setActiveStatus] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [noOfFiltersSelected, setNoOfFiltersSelected] = useState(false);
  const [filtersSelected, setFiltersSelected] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedOption1, setSelectedOption1] = useState("");
  const [selectedOption2, setSelectedOption2] = useState("");
  const [rechargeTransactionList, setRechargeTransactionList] = useState([]);
  const [allUserListExcel, setallUserProfileListExcel] = useState([]);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });
  const [sizeShow, setSizeShow] = useState();
  const buttonRef = useRef("");

  const columns = [
    {
      dataField: "",
      text: "",
      sort: false,
      style: { minWidth: "15px", textAlign: "center" },
      formatter: (cell, row) => {
        let states = { ...row };
        return (
          <div
            style={{ color: "black" }}
            onClick={() => {
              if (row && row.id) {
                handleTransactionDetails(row.id);
              }
            }}
          >
            <i style={{ fontSize: 18 }} className="fas fa-search" />
          </div>
        );
      },
    },
    {
      dataField: "createdDate",
      text: "Date",
      sort: true,
      style: { minWidth: "100px", textAlign: "Left" },
      formatter: (cell, row) => {
        return moment((row && row.createdDate) || null).format(
          "DD-MM-YY HH:mm:ss"
        );
      },
    },
    {
      dataField: "fullName",
      text: "Name",
      sort: false,
      style: { minWidth: "200px", textAlign: "Left" },
    },
    {
      dataField: "sender",
      text: "Sender",
      sort: false,
      style: { minWidth: "120px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
    // {
    //   dataField: "beneficiaryName",
    //   text: "Beneficiary",
    //   sort: false,
    //   headerStyle: { textAlign: "center" },
    //   style: { minWidth: "160px", textAlign: "center" },
    // },
    {
      dataField: "receiver",
      text: "receiver",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "130px", textAlign: "center" },
    },

    {
      dataField: "send",
      text: "Sent(AED)",
      sort: false,
      style: { minWidth: "100px", textAlign: "center" },
    },
    {
      dataField: "c3REF",
      text: "C3 Ref",
      sort: false,
      style: { minWidth: "100px", textAlign: "Left" },
      headerStyle: { textAlign: "center" },
    },
    {
      dataField: "partnerReference",
      text: "Ding Number",
      sort: false,
      style: { minWidth: "100px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
    {
      dataField: "status",
      text: "Status",
      sort: false,
      style: { minWidth: "100px", textAlign: "Left" },
    },
  ];

  useEffect(() => {
    if (filterForm) {
      console.log("useffect bruh", filterForm);
      getAllRechargeTransactions(filterForm);
    }
  }, [filterForm]);
  const rowOnClick = {
    onClick: (e, row, rowIndex) => {
      handleTransactionDetails(row.id);
    },
  };

  const getAllRechargeTransactions = (request) => {
    request.size = sizeShow || 10;
    setDataLoading(true);
    getRechargeTransactionList(request)
      .then((res) => {
        setDataLoading(false);
        if (res && res.data && res.data.rechargeTransactions.length > 0) {
          setRechargeTransactionList(res.data.rechargeTransactions);
        } else {
          setRechargeTransactionList([]);
        }
        setPagination({
          ...pagination,
          pageSize: sizeShow || 10,
          total: res.data.totalCount,
          current: request.page,
        });
      })
      .catch((err) => {
        setDataLoading(false);
        setRechargeTransactionList([]);
      });
  };

  const resetFilter = () => {
    setSearchBy("sender");
    // setSearchByValue('');
    setFiltersSelected(false);
    setRechargeTransactionList([]);
    setallUserProfileListExcel([]);
    setFromDate(null);
    setToDate(null);
    setSelectedOption("");
    setSelectedOption1("");
    setFilterValues(false);
    setSearchByValue("");
    setFilterForm(request);
  };
  const [transactionDetail, setTransactionDetail] = useState([]);

  const handleTransactionDetails = (id) => {
    getTabRechargeTransactionsDetails(id)
      .then((res) => {
        setTransactionDetailModel(true);
        setTransactionDetail(res && res.data);
        console.log(res);
      })
      .catch((err) => {
        setTransactionDetailModel(false);
        setTransactionDetail([]);
      });
  };

  const handleFIlter = () => {
    let request = {};
    if (searchBy === "name") {
      request = {
        ...filterForm,
        name: searchByValue.trim(),
        sender: "",
        receiver: "",
        createdDate: "",
        beneficiaryName: "",
        send: "",
        c3REF: "",
        status: "",
      };
    } else if (searchBy === "sender") {
      request = {
        ...filterForm,
        name: "",
        sender: searchByValue.trim(),
        receiver: "",
        createdDate: "",
        beneficiaryName: "",
        send: "",
        c3REF: "",
        status: "",
      };
    } else if (searchBy === "date") {
      request = {
        ...filterForm,
        name: "",
        sender: "",
        receiver: "",
        createdDate: searchByValue.trim(),
        beneficiaryName: "",
        send: "",
        c3REF: "",

        status: "",
      };
    } else if (searchBy === "beneficiary") {
      request = {
        ...filterForm,
        name: "",
        sender: "",
        receiver: "",
        createdDate: "",
        beneficiaryName: searchByValue.trim(),
        send: "",
        c3REF: "",

        status: "",
      };
    } else if (searchBy === "receiver") {
      request = {
        ...filterForm,
        name: "",
        sender: "",
        receiver: searchByValue.trim(),
        createdDate: "",
        beneficiary: "",
        send: "",
        c3REF: "",
        status: "",
      };
    } else if (searchBy === "sent_aed") {
      request = {
        ...filterForm,
        name: "",
        sender: "",
        receiver: "",
        createdDate: "",
        beneficiaryName: "",
        send: searchByValue.trim(),
        c3REF: "",
        status: "",
      };
    } else if (searchBy === "c3ref") {
      request = {
        ...filterForm,
        name: "",
        sender: "",
        receiver: "",
        createdDate: "",
        beneficiaryName: "",
        send: "",
        c3REF: searchByValue.trim(),
        status: "",
      };
    } else if (searchBy === "status") {
      request = {
        ...filterForm,
        name: "",
        sender: "",
        receiver: "",
        createdDate: "",
        beneficiaryName: "",
        send: "",
        c3REF: "",
        status: searchByValue.trim(),
      };
    }
    request.fromDate =
      (fromDate && moment(fromDate).format("YYYY-MM-DD")) || null;
    request.toDate =
      (toDate && moment(toDate).format("YYYY-MM-DD")) || moment().format();
    request.searchStatus = "";
    let a = "";
    if (selectedOption.length > 0) {
      selectedOption.forEach((v, i) => {
        a = a + v.value + (i + 1 < selectedOption.length ? "," : "");
      });
    }
    request.page = 1;
    request.searchStatus = a; // TODO - NEED TO REMOVE
    setFilterForm(request);
  };

  const handleChange = (selectedOption) => {
    console.log(selectedOption);
    if (selectedOption) {
      setSelectedOption([...selectedOption]);
    } else {
      setSelectedOption("");
    }
  };
  const handleChange1 = (selectedOption1) => {
    console.log(selectedOption1);
    if (selectedOption1) {
      setSelectedOption1([...selectedOption1]);
    } else {
      setSelectedOption1("");
    }
  };

  const statusFilter = () => {
    setNoOfFiltersSelected(selectedOption1.length + selectedOption.length);
    setModalShow(false);
    setFiltersSelected(true);
    selectedOption.map((option) => {
      switch (option.label) {
        case "Success":
          setBlockStatus(true);
          return setFilterValues(!filterValues);
          break;

        case "Failed":
          setVerifiedStatus(true);
          return setFilterValues(!filterValues);

        default:
          return "";
      }
    });
  };

  const typeFilter = () => {
    setNoOfFiltersSelected(selectedOption1.length + selectedOption.length);
    setModalShow(false);
    setFiltersSelected(true);
    selectedOption1.map((option) => {
      switch (option.label) {
        case "local":
          setBlockStatus(true);
          return setFilterValues(!filterValues);
          break;
        case "country":
          setVerifiedStatus(true);
          return setFilterValues(!filterValues);
        default:
          return "";
      }
    });
  };

  let searchByValuePlaceholder = "";
  if (searchBy === "name") {
    searchByValuePlaceholder = "Amit Pandit";
  } else if (searchBy === "sender") {
    searchByValuePlaceholder = "971xxxxxxxxx";
  } else if (searchBy === "beneficiary") {
    searchByValuePlaceholder = "amitxxxx";
  } else if (searchBy === "receiver") {
    searchByValuePlaceholder = "784xxxxxxxxxxxx";
  } else if (searchBy === "c3ref") {
    searchByValuePlaceholder = "MB0xxxxxxxxxxxx";
  } else if (searchBy === "status") {
    searchByValuePlaceholder = "Active";
  } else {
    searchByValuePlaceholder = "1234567890";
  }

  const onExcelClciked = (filterForm) => {
    let request = filterForm;
    request.page = 1;
    request.size = "";
    getRechargeTransactionList(request)
      .then((res) => {
        if (res && res.data && res.data.rechargeTransactions.length > 0) {
          let data = res.data.rechargeTransactions.map((element) => {
            if (element.registrationDate) {
              element.registrationDate = moment(
                element.registrationDate
              ).format("DD-MM-YYYY");
            }
            return element;
          });
          setallUserProfileListExcel(() => data);
          buttonRef.current.click();
        } else {
          setallUserProfileListExcel([]);
        }
      })
      .catch((err) => {
        setallUserProfileListExcel([]);
      });
  };

  return (
    <RakRechargePresentational
      searchBy={searchBy}
      rowOnClick={rowOnClick}
      transactionDetail={transactionDetail}
      setSearchByValue={setSearchByValue}
      setSearchBy={setSearchBy}
      searchByValuePlaceholder={searchByValuePlaceholder}
      searchByValue={searchByValue}
      fromDate={fromDate}
      setFromDate={setFromDate}
      toDate={toDate}
      setToDate={setToDate}
      setModalShow={setModalShow}
      filtersSelected={filtersSelected}
      noOfFiltersSelected={noOfFiltersSelected}
      resetFilter={resetFilter}
      handleFIlter={handleFIlter}
      filterValues={filterValues}
      transactionData={rechargeTransactionList}
      dataLoading={dataLoading}
      buttonRef={buttonRef}
      filterForm={filterForm}
      onExcelClciked={onExcelClciked}
      allUserListExcel={allUserListExcel}
      columns={columns}
      columnsCsv={columnsCsv}
      pagination={pagination}
      setFilterForm={setFilterForm}
      setSizeShow={setSizeShow}
      modalShow={modalShow}
      handleChange={handleChange}
      handleChange1={handleChange1}
      options={options}
      options1={options1}
      selectedOption={selectedOption}
      selectedOption1={selectedOption1}
      selectedOption2={selectedOption2}
      statusFilter={statusFilter}
      typeFilter={typeFilter}
      transactionDetailModel={transactionDetailModel}
      setTransactionDetailModel={setTransactionDetailModel}
    />
  );
};

export default RechargeTransaction;
